// SEXYSHOES | Searchanise mobile active swatch sync DISABLED
// Native Searchanise active classes now control swatch/image logic.
// Do not add ss-snize-active-swatch here because it can conflict with Slick v8.

document.addEventListener('Searchanise.Loaded', function () {
  // Intentionally disabled.
});